import React from 'react';
import { Callout, Step, DocHeading, DocTable, Shot } from './components';

function PageAutoPotion({ navigate }) {
  return (
    <div>
      <h1 className="text-[2.5rem] leading-[1.1] font-semibold text-white tracking-[-0.02em] mb-3">Potion</h1>
      <p className="text-gray-400 leading-relaxed mb-8">
        Auto Potion drinks a health potion when your health drops below the line you set. It
        drinks the same way you do when you press the key, so the game still decides the
        cooldown. Everything on this page is on the{' '}
        <strong className="text-white">AUTOPILOT &rsaquo; Potion</strong> tab.
      </p>

      <DocHeading>Set It Up</DocHeading>
      <Step n={1} title="Turn on Drink health potions">
        This is the switch in the <strong>AUTO POTION</strong> card. While it is on, a green dot
        shows next to <strong>Potion</strong> in the list on the left.
      </Step>
      <Step n={2} title="Set Drink below">
        The health level where it drinks, from 10% to 90%. Out of the box it is 35%, the same
        as the game&rsquo;s own autoplay.
      </Step>
      <Step n={3} title="Pick which potion goes first">
        <strong>Strongest first</strong> (the default) or <strong>Weakest first</strong>.
      </Step>

      <Shot
        name="auto-potion-01-tab.png"
        tab="AUTOPILOT › Potion"
        caption="Auto Potion switched on: it drinks below 50% health, 46 potions are left in the bag."
        shoot="menushot (stage potion): bekapcsolva, 50%-os küszöb, 46 poti, a következő 80%-ot tölt vissza, 14 megivott."
      />

      <DocHeading>Which Potions It Drinks</DocHeading>
      <p className="text-sm text-gray-400 mb-4">
        Healing potions only. Food, event drinks and buff drinks are never touched, even if the
        game files them next to the potions. Strength is how much health a potion gives back at
        once, read from the game&rsquo;s own item data, not from its rarity. Slow regeneration
        potions always come last, whichever order you picked.
      </p>

      <DocHeading>The Lines on the Card</DocHeading>
      <DocTable
        headers={['Line', 'What it shows']}
        rows={[
          [<strong className="text-white">Potions in the bag</strong>, <>How many healing potions you have. <span className="text-amber-300">none left</span> when you ran out.</>],
          [<strong className="text-white">Next potion</strong>, 'How much health the next one gives back, for example "restores 80%".'],
          [<strong className="text-white">Health</strong>, 'Your health right now. It turns orange at or below the line.'],
          [<strong className="text-white">Drunk</strong>, 'How many potions it drank since the bot was loaded.'],
          [<strong className="text-white">Last try</strong>, <>Only shows when a try went wrong: <em>no answer</em> or <em>no player</em> (the game was loading). A potion cooldown is normal and is not shown here.</>],
        ]}
      />

      <Callout type="info">
        When the potions run out, the bot only tells you. It does not go back to town to buy more.
        It works in manual play too, not just while a route runs.
      </Callout>

      <DocHeading>Related</DocHeading>
      <p className="text-sm text-gray-400 mb-4">
        Getting back up after a death is the job of{' '}
        <button onClick={() => navigate('auto-revive')} className="text-brand-300 hover:text-brand-200 underline underline-offset-2">AUTOPILOT &rsaquo; Revive</button>.
        Keeping your essence slot filled is{' '}
        <button onClick={() => navigate('auto-essence')} className="text-brand-300 hover:text-brand-200 underline underline-offset-2">AUTOPILOT &rsaquo; Essence</button>.
      </p>
    </div>
  );
}

export default PageAutoPotion;
